import { Stack } from 'expo-router';
import React from 'react';

function CreditLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default CreditLayout;
